import { Grid } from '@mui/material';
import { memo, useEffect, useState } from 'react';

import useTopPanel from 'hooks/useTopPanel';
import ObjectFilter from 'components/ui/filters/items/ObjectFilter';

import ProductStatistics from './items/ProductStatistics';

const StatisticsObject = () => {
  const { setComponent } = useTopPanel();
  const [objectData, setObjectData] = useState({
    product: {},
    expense: {},
    square: 0,
  });

  useEffect(() => {
    setComponent(
      <div className='component-title flex gap-8 items-center'>
        Mahsulotlar kirim statistikasi
        {/* <div className='min-w-[250px]'>
          <ObjectFilter autoSelect />
        </div> */}
      </div>
    );
  }, []);

  return (
    <div className='component-wrapper boss-residential-complex-wrapper'>
      <Grid container spacing={2} columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
        <Grid item={true} lg={12} md={12} sm={12} xs={12}>
          <ProductStatistics setData={setObjectData} />
        </Grid>
      </Grid>
    </div>
  );
};
export default memo(StatisticsObject);
